<template>
    <v-card>
        <v-card-title>
            <v-row>
                <v-col cols="12">Resumo</v-col>
            </v-row>
        </v-card-title>
        <v-card-text>
            <v-data-table class="elevation-1"
                          :headers="headers"
                          :items="cashBookItems"
                          :itemsPerPage="-1"
                          return-object
                          hide-default-footer
                          disable-pagination>
                <template v-slot:bottom></template>
                <template v-slot:item.starting_amount="{ value }">
                    <span>{{
                        $filters.currency(value, 'BRL')
                    }}</span>
                </template>
                <template v-slot:item.ending_amount="{ value }">
                    <span>{{
                        $filters.currency(value, 'BRL')
                    }}</span>
                </template>
                <template v-slot:item.variation="{ value }">
                    <span :class="value >= 0 ? 'text-green' : 'text-red'">{{
                        $filters.currency(value, 'BRL')
                    }}</span>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>
import api from '@/services'

export default {
    components: {},
    computed: {
        cashBookItems() {
            const vm = this;
            let result = [];
            let totalBefore = 0;
            let totalAfter = 0;
            let totalVar = 0;

            vm.history.map(d => Object.assign(d))
                .sort((a, b) => a.movement_date.localeCompare(b.movement_date))
                .forEach(d => {
                    const ret = {
                        cashier_id: d.cashier_id,
                        cashier_name: d.cashier_name,
                        group_acronym: d.group_acronym,
                        starting_date: d.movement_date,
                        ending_date: d.movement_date,
                        starting_amount: d.amount_before,
                        ending_amount: d.amount_after,
                        variation: d.amount_after - d.amount_before
                    };
                    const val = result.find(r => r.cashier_id === d.cashier_id);

                    if (!val) {
                        result.push(ret);
                        totalBefore += d.amount_before;
                    } else {
                        val.ending_amount += d.amount;
                        val.variation = val.ending_amount - val.starting_amount;
                    }
                    totalAfter += d.amount;
                });
            totalAfter += totalBefore;
            totalVar = totalAfter - totalBefore;

            if (result?.length > 0) {
                for (let cashier of vm.cashiersList) {
                    if (!result.find(o => o.cashier_id === cashier.id)) {
                        result.push({
                            cashier_id: cashier.id,
                            cashier_name: cashier.name,
                            group_acronym: cashier.group.acronym,
                            starting_amount: 0,
                            ending_amount: 0,
                            variation: 0
                        });
                    }
                }
            }
            result.sort((a, b) => a.cashier_name.localeCompare(b.cashier_name)).push({
                cashier_id: 0,
                cashier_name: 'TOTAL',
                group_acronym: '',
                starting_amount: totalBefore,
                ending_amount: totalAfter,
                variation: totalVar
            });
            return result;
        }
    },
    props: {
        user: Object,
        history: Array,
        startDate: String,
        endDate: String,
        selectedCashiers: Array
    },
    data() {
        return {
            requestingApi: false,
            headers: [
                { title: "Caixa", align: "start", key: "cashier_name", sortable: true },
                { title: "Saldo Inicial", align: "end", key: "starting_amount", sortable: true },
                { title: "Saldo Final", align: "end", key: "ending_amount", sortable: true },
                { title: "Variação", align: "end", key: "variation", sortable: true },
            ],
            cashiersList: []
        };
    },
    created() {
        const vm = this;

        if (vm.user?.access_level >= vm.$USER_ACCESS_LEVELS_DIC.ADMIN.value) {
            vm.headers.push({ title: "Grupo", align: "end", key: "group_acronym", sortable: true });
        }
        vm.loadCashiers();
    },
    methods: {
        loadCashiers() {
            const vm = this;

            if (!vm.requestingApi) {
                vm.requestingApi = true;
                return new Promise((resolve, reject) => {
                    api.cashier
                        .list({ withGroup: true, cashier_ids: vm.selectedCashiers }, 1)
                        .then((result) => {
                            vm.cashiersList = result || [];
                        })
                        .catch((err) => {
                            if (err.message) {
                                vm.$notify({
                                    type: "warn",
                                    text: err.message,
                                });
                            }
                        })
                        .finally(() => {
                            vm.requestingApi = false;
                        });
                });
            }
            return [];
        }
    }
};
</script>